<div class="dialog">

    <form class="edit-file-form" [formGroup]="inputForm">
        <div class="dialog-header">
            <h5>Edit File</h5>
            <span class="dialog-close" (click)="close()" (keypress)="close()">
                <img alt="close" [src]="'images/close.svg' | assetUrl" class="black-icon cursor-pointer" draggable="false">
            </span>
        </div>
        <mat-dialog-content class="dialog-content">
            <label>Description</label>

            <div class="form-input">
                <input type="text" formControlName="description">
            </div>

            <label>Tags</label>

            <div class="chips-container">
                <mat-form-field class="edit-file-form-chips">
                    <mat-chip-grid #chipGrid>
                        @for (tag of this.inputForm.controls['tags'].value; track tag) {
                        <mat-chip-row (removed)="removeTag(tag)" [editable]="true" (edited)="editTag(tag, $event)">
                            {{tag}}
                            <button matChipRemove [attr.aria-label]="'remove ' + tag">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                        }
                        <input [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTag($event)" />
                    </mat-chip-grid>
                </mat-form-field>
            </div>

            <label>File</label>

            <!-- <div>
                <input type="file" formControlName="description" [placeholder]="fileElement.name">
            </div> -->
            <div class="browse-input">
                <mat-form-field>
                    <input matInput type="text" formControlName="fileName" readonly>
                    <button mat-button matSuffix mat-stroked-button [matMenuTriggerFor]="browseMenu"
                        [disabled]="data?.isMobileScreen" class="browse-btn"> Browse </button>
                </mat-form-field>

                <mat-menu #browseMenu="matMenu" yPosition="above" xPosition="before" class="browse-panel">
                    <button class="mat-menu-item-button" mat-menu-item (click)="fileInput.click()">
                        <label for="fileInput">
                            <img [src]="'images/computer.svg' | assetUrl" alt="your computer icon" class="icon-mr-5"
                                draggable="false" />
                            Your computer
                        </label>
                    </button>
                    <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file"
                        accept=".7z, .rar, .zip, .email, .eml, .emlx, .msg, .oft, .bmp, .gif, .jpeg, .jpg, .png, .tif, .tiff, .doc, .dot, .docx, .docm, .dotx, .dotm, .docb, .txt, .rtf, .pdf, .xls, .csv, .xml, .xlt, .xlm, .xlsx, .xlsm, .xltx, .xltm, .xlsb, .xlw, .xml, .ppt, .pot, .pps, .pptx, .pptm, .potx, .potm, .ppsx, .ppsm, .sldx, .sldm, .xps, .one" />
                </mat-menu>
            </div>
            <div class="notes">Select new file, or leave as is to keep existing.</div>
        </mat-dialog-content>

        <mat-dialog-actions [align]="'end'">
            <button mat-raised-button class="cancel-btn" (click)="close()">Cancel</button>
            <button mat-raised-button class="submit-btn" type="button" (click)="onUpdate()"> Update </button>
        </mat-dialog-actions>
    </form>
</div>